// ABOUTME: Pure helpers for 1A's Too Much picks: what to send, what to seed from the stored crossing, and whether they differ.
// ABOUTME: A focused category counts as engaged, so it is sent even with no supports.

import type { CrossingTooMuchPick, CrossingTooMuchSelection } from '../../../../types/api';

// Every category with at least one pick, plus the focused one even if it has none yet.
export function picksToSend(categoryPicks: Record<string, string[]>, focused: string | null): CrossingTooMuchPick[] {
  const codes = Object.keys(categoryPicks).filter(code => categoryPicks[code].length > 0);
  if (focused && !codes.includes(focused)) codes.push(focused);
  return codes.map(categoryCode => ({ categoryCode, supports: categoryPicks[categoryCode] ?? [] }));
}

export function picksFromStored(stored: CrossingTooMuchSelection[]): Record<string, string[]> {
  return Object.fromEntries(stored.map(selection => [selection.categoryCode, selection.supports]));
}

export function focusFromStored(stored: CrossingTooMuchSelection[]): string | null {
  return stored[0]?.categoryCode ?? null;
}

// Compared as sets, so a different order is not a difference.
export function picksDiffer(sent: CrossingTooMuchPick[], stored: CrossingTooMuchSelection[]): boolean {
  if (sent.length !== stored.length) return true;
  const storedByCode = new Map(stored.map(selection => [selection.categoryCode, new Set(selection.supports)]));
  return sent.some(pick => {
    const storedSupports = storedByCode.get(pick.categoryCode);
    const sentSupports = new Set(pick.supports ?? []);
    return !storedSupports || storedSupports.size !== sentSupports.size || [...sentSupports].some(label => !storedSupports.has(label));
  });
}
